import React, { useState } from "react";
import { View, StyleSheet } from "react-native";
import { TextInput } from "react-native";
import config from "../../config/config";
import AppText from "../AppText";
import IconTouchable from "../IconTouchable";
import ListItemSeperator from "./ListItemSeperator";

function ListItemTextInput({
    itemID = false,
    title,
    onComplete = () => {},
    onChange = () => {},
    value,
    numberInput = false,
    maxLength,
    autoFocus,
    setValue = () => {},
    footer,
    onConfirm,
}) {
    const [newTextValue, setNewTextValue] = useState(value);

    return (
        <>
            <View style={styles.component}>
                <View style={styles.inputBox}>
                    <TextInput
                        spellCheck={false}
                        autoCorrect={false}
                        autoFocus={autoFocus}
                        style={config.text}
                        onChangeText={(text) => {
                            if (numberInput) {
                                setNewTextValue(text.replace(/[^0-9]/g, ""));
                                onChange(text.replace(/[^0-9]/g, ""));
                            } else {
                                setNewTextValue(text);
                                onChange(text);
                            }
                            setValue(text);
                        }}
                        onBlur={async () => {
                            if (newTextValue == value) {
                                return;
                            }
                            if (itemID) {
                                await onComplete.request(itemID, newTextValue);
                            } else {
                                onComplete(newTextValue);
                            }
                        }}
                        value={newTextValue}
                        keyboardType={numberInput ? "numeric" : "default"}
                        placeholder={numberInput ? "0" : title}
                        placeholderTextColor={config.colors.danger}
                        maxLength={maxLength}
                        hitSlop={{ top: 20, bottom: 20, left: 80, right: 80 }}
                        textAlign={"center"}
                    />
                </View>
                {onConfirm && (
                    <View style={{ paddingLeft: 20 }}>
                        <IconTouchable name="check" size={40} onPress={() => onConfirm()} />
                    </View>
                )}
            </View>
            {footer && (
                <View style={styles.footer}>
                    <AppText>{footer}</AppText>
                </View>
            )}
            <ListItemSeperator />
        </>
    );
}

const styles = StyleSheet.create({
    component: {
        backgroundColor: config.colors.white,
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 10,
        paddingHorizontal: 20,
        alignItems: "center",
        justifyContent: "space-between",
    },
    inputBox: {
        backgroundColor: config.colors.light,
        paddingHorizontal: 20,
        paddingVertical: 10,
        flex: 1,
    },
    footer: {
        backgroundColor: config.colors.white,
        paddingHorizontal: 20,
        paddingBottom: 5,
    },
});

export default ListItemTextInput;
